/**
 * Utility functions for MSAL operations
 */

/**
 * Check if the current page load is a result of an authentication redirect
 */
export function isAuthenticationRedirect(): boolean {
  const urlParams = new URLSearchParams(window.location.search);
  const hash = window.location.hash;
  
  // Check for common MSAL redirect parameters
  const hasAuthCode = urlParams.has('code');
  const hasState = urlParams.has('state');
  const hasError = urlParams.has('error');
  const hasAccessToken = hash.includes('access_token');
  const hasIdToken = hash.includes('id_token');
  
  return hasAuthCode || hasState || hasError || hasAccessToken || hasIdToken;
}

/**
 * Check if there are authentication parameters in the URL that need to be processed
 */
export function hasAuthenticationParams(): boolean {
  const urlParams = new URLSearchParams(window.location.search);
  const hash = window.location.hash;
  
  // Check for OAuth/OIDC parameters
  const authParams = [
    'code',
    'state', 
    'session_state',
    'error',
    'error_description'
  ];
  
  const hasUrlParams = authParams.some(param => urlParams.has(param));
  const hasHashParams = hash.includes('access_token') || 
                       hash.includes('id_token') || 
                       hash.includes('error');
  
  return hasUrlParams || hasHashParams;
}


